/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to keep in storage (upper bound, not display count) */
  static #MAX_STORED = 20;

  /**
   * @deprecated Display count now comes from the block's `max_products` setting (read in recently-viewed.js
   * via the container's data-max-products attribute), not from this static value. Kept only as a fallback.
   */
  static get maxProducts() {
    return this.#MAX_STORED;
  }

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => String(id) !== String(productId));
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_STORED);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}